const vimeoEmbedUrl = (url) => {
  if (!url) return url
  if (url.includes('player.vimeo.com/video/')) return url
  const match = url.match(/vimeo\.com\/(\d+)/)
  if (match) return `https://player.vimeo.com/video/${match[1]}`
  return url
}

export default vimeoEmbedUrl
